import React from 'react';
var UserSelectionContext = React.createContext({
    frozenIds: [],
    t: function () { },
    defaultUserAvatar: null,
    single: false,
    tabs: [],
    fixedUsers: [],
    searchPlaceHolder: '',
    resultUsers: [],
    currentUser: { pin: '', app: '', teamId: '' },
    hasItemSelector: false,
    itemSelectorOptions: [],
    simpleDeptInfoList: null,
    virtualDeptInfoList: null,
    canSelectDept: false,
    canSelectAll: false,
    onSelectAll: function () { },
    isWebpSupported: true,
    bodyHeight: null,
    maxSelectedNum: null,
    isForwardMode: false,
    maxSelectedSingleNum: null,
    isShowRemark: true,
    chooseOnlyDepart: false,
    customTabs: [],
    selectedCountText: '',
    canSelectStranger: false,
    searchValue: '',
    dataListFilter: null,
    setSearchValue: Function,
    selectedLimit: null,
    setSelectedLimit: Function,
    maxNumber: -1,
    totalCount: 0,
});
export default UserSelectionContext;
//# sourceMappingURL=context.js.map